import { render, staticRenderFns } from "./importTemplate.vue?vue&type=template&id=eb770e68&scoped=true"
import script from "./importTemplate.vue?vue&type=script&lang=js"
export * from "./importTemplate.vue?vue&type=script&lang=js"
import style0 from "./importTemplate.vue?vue&type=style&index=0&id=eb770e68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb770e68",
  null
  
)

export default component.exports